import useComputed from '@/hooks/use-computed'
import api from '@/services/api/dataElementsRequest.js'
import { immerable } from "immer"
import { useState } from 'react'

class Requests {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.status = params.status
		this.type = params.type
		this.dataElementId = params.dataElementId
		this.created = params.created
		this.organizationId = params.organizationId
		this.useCaseId = params.useCaseId
		this.dataElement = params.dataElement
		this.useCase = params.useCase
		this.systems = params.systems
		this.participant = params.participant
	}
}

const useRequests = (requestId) => {

	const [items, setItems] = useComputed([])

	const [meta, setMeta] = useState(null)

	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";
		
		const [error, data] = await api.index({
			params
		})
		if (error) {
			return setError(error)
		}
		const { meta } = data
		if (!Array.isArray(data.items)) {
			return setError('Request is not an array')
		}
		setLoading(false)
		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Requests(params))
		setMeta(meta)
		return setItems(newItems)
	}

	async function find(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.index({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		if (!Array.isArray(data.items)) {
			return setError('Request is not an array')
		}

		const serializedData = data.items.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new Requests(params))

		return newItems
	}

	function serialize(entry) {
		return {
			id: entry.id,
			status: entry.status,
			type: entry.type,
			dataElementId: entry.dataElementId,
			created: entry.createdAt,
			organizationId : entry.orgId,
			useCaseId: entry.useCaseId,
			dataElement: entry.dataElement,
			useCase: entry.useCase,
			systems: entry.systems,
			participant: entry.participant
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		meta
	}

}

export default useRequests;
